import { Head } from '@inertiajs/react';
import BasesContent, { isBasesEdition } from '@/components/bases/bases-content';
import type { LandingsBases } from '@/types';

// `app/(public)/26-co/bases/page.tsx`.
export default function Bases({ edition, title, description }: LandingsBases) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
      </Head>
      <div className="min-h-screen bg-background">
        <div className="mx-auto max-w-4xl px-6 py-12">
          {isBasesEdition(edition) && <BasesContent edition={edition} />}
        </div>
      </div>
    </>
  );
}
